import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';

// Value from css to minimize content jumping
const INITIAL_HEADER_HEIGHT = 56;

const windowSize = handleActions({
  RESIZE: (state, { payload }) => ({
    ...state,
    ...payload,
  }),
}, {
  width: 1,
  height: 1,
});

const breakpoint = handleActions({
  UPDATE_BREAKPOINT: (state, { payload }) => payload,
}, 0);

const headerHeight = handleActions({
  UPDATE_HEADER_HEIGHT: (state, {payload}) => payload,
}, INITIAL_HEADER_HEIGHT);

export default combineReducers({
  windowSize,
  breakpoint,
  headerHeight,
});



// WEBPACK FOOTER //
// ./src/reducer/events.js